// Steps of the purchase funnel, where the chat launcher would sit over the
// sticky price bar and its CTA: the old per-step quote flow and quote setup.
// Not the /quote landing page or /quote-complete, which offers chat itself.
const FUNNEL_PATH = /^\/(quote\/[^/]+\/|quote-setup\/)/

export default ({ app }, inject) => {
  if (process.client) {
    // Hides the launcher bubble while anything asks it to (the funnel route,
    // the quick quote panel). Done with a class and CSS (assets/main.scss)
    // rather than zE('messenger', 'hide'): the GTM tag can inject the
    // snippet more than once, and zE only reaches the last copy. The
    // messaging window itself stays reachable from the nav's chat link.
    const hiders = new Set()
    const hideFor = (reason, hidden) => {
      if (hidden) hiders.add(reason)
      else hiders.delete(reason)
      document.documentElement.classList.toggle(
        'ps-chat-hidden',
        hiders.size > 0
      )
    }
    inject('chatLauncher', { hideFor })

    const applyRoute = (route) =>
      hideFor('funnel', FUNNEL_PATH.test(route.path))
    applyRoute(app.router.currentRoute)
    app.router.afterEach(applyRoute)

    const isMobile = () => window.innerWidth < 768

    // Helper to wait for zE to be available. Zendesk is injected by GTM on
    // the deferred `ps_deferred` event (plugins/deferred-third-party.js):
    // after the load event, then idle or first interaction — which can be
    // well past 10 s on a slow phone, so the window is generous.
    const waitForZE = (callback, attempts = 0) => {
      if (typeof zE === 'function') {
        callback()
      } else if (attempts < 240) {
        // Try for 60 seconds (240 * 250ms)
        setTimeout(() => waitForZE(callback, attempts + 1), 250)
      }
    }

    waitForZE(() => {
      // 1. Hide the default Zendesk launcher on mobile
      if (isMobile()) {
        zE('messenger', 'hide')
      }

      // 4. Handle the close event: Listen for user closing the chat on mobile
      zE('messenger:on', 'close', () => {
        if (isMobile()) {
          // ensure the launcher bubble goes back to being hidden
          zE('messenger', 'hide')
        }
      })

      // Ensure it behaves correctly on resize
      let resizeTimer
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer)
        resizeTimer = setTimeout(() => {
          if (isMobile()) {
            zE('messenger', 'hide')
          } else {
            zE('messenger', 'show')
          }
        }, 200)
      })
    })
  }
}
